<div class="PGEmbedEditor">
    @for (item of value; track item) {
        <div class="form-group {{ multi ? 'card form-group pb-2 pt-3 px-3' : ''}}">
            <div class="col-12 pb-2">
                @if (multi) {
                    <div class="float-end">
                        <button class="btn btn-danger btn-sm" (click)="removeItem(item)">
                            <i class="fa-regular fa-trash"></i>
                        </button>
                    </div>
                }
                <label>
                    <b>{{ 'pg-embed-editor.field-src' | locTranslate}}</b>
                </label>
                <textarea class="form-control mb-2" [(ngModel)]="item.src" (ngModelChange)="onValueChange()"></textarea>
            </div>
            <div class="col-6 pb-2" [appPgAnimations]="item.src ? 'EnterT' : 'ExitT'" pgAnimationsSkipFirst>
                <label>
                    <b>{{ 'pg-embed-editor.field-fullscreen' | locTranslate}}</b>
                </label>
                <app-pg-switch [(ngModel)]="item.fullscreen" (ngModelChange)="onValueChange()"></app-pg-switch>
            </div>
            <div class="col-6 pb-2" [appPgAnimations]="item.src ? 'EnterT' : 'ExitT'" pgAnimationsSkipFirst>
                <label>
                    <b>{{ 'pg-embed-editor.field-ratio' | locTranslate}}</b>
                </label>
                <app-pg-select [(ngModel)]="item.ratio" [options]="embedRatioOptions" [required]="true" (ngModelChange)="onValueChange()"></app-pg-select>
            </div>
            <div class="col-6 pb-2" [appPgAnimations]="(item.src && item.ratio == 'specify') ? 'EnterT' : 'ExitT'" pgAnimationsSkipFirst>
                <label>
                    <b>{{ 'pg-embed-editor.field-width' | locTranslate}}</b>
                </label>
                <input type="number" class="form-control" step="1" min="0" required [(ngModel)]="item.width" (ngModelChange)="onValueChange()"/>
            </div>
            <div class="col-6 pb-2" [appPgAnimations]="(item.src && item.ratio == 'specify') ? 'EnterT' : 'ExitT'" pgAnimationsSkipFirst>
                <label>
                    <b>{{ 'pg-embed-editor.field-height' | locTranslate}}</b>
                </label>
                <input type="number" class="form-control" step="1" min="0" required [(ngModel)]="item.height" (ngModelChange)="onValueChange()"/>
            </div>
        </div>
    }
    @if (multi) {
        <div class="text-end">
            <button class="btn btn-primary btn-sm" (click)="addItem()">
                <i class="fa-regular fa-plus"></i><span>{{ 'pg-embed-editor.add-item' | locTranslate}}</span>
            </button>
        </div>
    }
</div>